import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Col, Row } from "react-bootstrap";
import { BackLogoIconButton } from "../../../../../reusableComponents/smallReusableComponent/LoginTopLogoAndText";
import { TopTextReusableComponent } from "../../../../../vendorOnboradingComponents/reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent";
import {
  ReusableOnboardingButton,
  ReusableOnboardingLink,
} from "../../../../../vendorOnboradingComponents/reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import InputNumberFunc from "../../../../../../function/InputNumberFunc";
// import Switch from "react-switch";
import {
  NewInputText,
  SelectBoxMUiInputComponent,
} from "../../../../../reusableComponents/inputReusableComponent/InputBoxComponent";
import { FormControl, Select, InputLabel, MenuItem } from "@material-ui/core";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import { ToggleButtonWithYesNo } from "../../AllButton/ToggleButtonReuse";
import { useFormik } from "formik";
import * as yup from "yup";
import Alert from "react-s-alert";
import LeftSideNavigation from "../../../../navigationSection/LeftSideNavigation";
import { TopNavigationBarMobile } from "../../../../navigationSection/TopNavigationBarMobile";
import RightSideNavigation from "../../../../navigationSection/RightSideNavigation";
import BottomNavigationMobile from "../../../../navigationSection/BottomNavigationMobile";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { update_new_subscription_for_vendor } from "../../../../../../store/actions/authAction";
import { AmealioLoader } from "../../../../../Loader/AmealioLoader";
import { SliderReusableComponent } from "../../../../../reusableComponents/sliderReusableComponent/SliderReusableComponent";
import isEmpty from "../../../../../../store/validation/is-Empty";
import { MobileTopHeader } from "../../../../../reusableComponents/sliderReusableComponent/MobileTopHeader";
import Media from "react-media";

const validationSchema = yup.object({
  minimum_person: yup.number().required("minimum person is required"),
  min_person: yup.number().required("Maximum person is required"),
  table_kept_for: yup.number().required("table kept is required"),
  cut_off_time: yup.number().required("cut off time is required"),
  max_day_ahead: yup
    .number()
    .required("max days ahead is required")
    .min(1, "minimum 1 day")
    .max(180, "maximum 180 days"),
  reservation_capacity: yup
    .number()
    .required("reservation capacity is required")
    .min(1, "minimum 1%")
    .max(99, "maximum 99%"),
  reservation_time_slot: yup
    .string()
    .required("reservation time slot is required"),
  auto_cancel: yup.number().required("auto cancel is required"),
});

export const EditReservationSubscription = (props) => {
  let history = useHistory();
  const [state, setState] = useState({
    same_day_reservation: false,
    casualReservationAutoAccept: false,
  });

  const validate = () => {
    const errors = {};
    if (formik.values.minimum_person === 0) {
      errors.minimum_person = "at least 1 mimimum person is required";
    }
    if (formik.values.min_person === 0) {
      errors.min_person = "at least 1 mimimum person is required";
    }
    return errors;
  };

  const casualSamedayReservationHandler = (e) => {
    setState({
      ...state,
      same_day_reservation: !state.same_day_reservation,
    });
  };

  const casualReservationAutoAcceptHandler = (e) => {
    setState({
      ...state,
      casualReservationAutoAccept: !state.casualReservationAutoAccept,
    });
  };

  const formik = useFormik({
    initialValues: {
      minimum_person: "",
      table_kept_for: "",
      minimum_lead: "",
      cut_off_time: "",
      max_day_ahead: "",
      reservation_capacity: "",
      reservation_time_slot: 15,
      min_person: "",
      auto_cancel: "",
      order_ahead: true,
    },
    validationSchema,
    validate,

    onSubmit: (values) => {
      var valuesData = {
        value:
          values.minimum_person === "" &&
          values.table_kept_for === "" &&
          state.same_day_reservation === false &&
          values.minimum_lead === "" &&
          values.cut_off_time === "" &&
          values.max_day_ahead === "" &&
          values.reservation_capacity === "" &&
          values.reservation_time_slot === "" &&
          state.casualReservationAutoAccept === false &&
          values.min_person === "" &&
          values.order_ahead === true
            ? false
            : true,
        minimum_person: values.minimum_person,
        table_kept_for: values.table_kept_for,
        same_day_reservation: state.same_day_reservation,
        minimum_lead: values.minimum_lead,
        cut_off_time: values.cut_off_time,
        max_day_ahead: values.max_day_ahead,
        reservation_capacity: values.reservation_capacity,
        reservation_time_slot: values.reservation_time_slot,
        auto_accept: {
          value: state.casualReservationAutoAccept,
          min_person: values.min_person,
        },
        auto_cancel: values.auto_cancel,
        order_ahead: values.order_ahead,
      };
      const token = props.auth.user.accessToken;
      const subscriptionId = props.subscription._id;
      let formData = props.allSubscriptionsData;
      if (props?.casualDiningService) {
        formData.casual_dining_status.seating.reservation = valuesData;
      } else if (props?.multiDiningService) {
        formData.multi_service_business_status.seating.reservation = valuesData;
      }
      props.update_new_subscription_for_vendor(
        subscriptionId,
        formData,
        token,
        onSuccess
      );
    },
  });

  const onSuccess = (e) => {
    Alert.success("<h4>Reservation changes add successfully</h4>", {
      position: "top-right",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
    history.push("/edit-seating-subscription");
  };

  const [count, setCount] = useState(1);
  const onClickSave = () => {
    setCount(count + 1);
    formik.handleSubmit();
  };

  const maxLengthCheck = (object) => {
    if (object.target.value.length > object.target.maxLength) {
      object.target.value = object.target.value.slice(
        0,
        object.target.maxLength
      );
    }
  };

  // useEffect(() => {
  //   formik.setFieldValue("max_date", "");
  // }, []);
  // for set focus
  useEffect(() => {
    if (formik.errors && formik.errors.minimum_person) {
      let minimum_personElement = document.getElementById("minimum_person");
      minimum_personElement.focus();
    } else if (formik.errors && formik.errors.table_kept_for) {
      let table_kept_forElement = document.getElementById("table_kept_for");
      table_kept_forElement.focus();
    } else if (formik.errors && formik.errors.cut_off_time) {
      let cut_off_timeElement = document.getElementById("cut_off_time");
      cut_off_timeElement.focus();
    } else if (formik.errors && formik.errors.max_day_ahead) {
      let max_day_aheadElement = document.getElementById("max_day_ahead");
      max_day_aheadElement.focus();
    } else if (formik.errors && formik.errors.reservation_capacity) {
      let reservation_capacityElement = document.getElementById(
        "reservation_capacity"
      );
      reservation_capacityElement.focus();
    } else if (formik.errors && formik.errors.reservation_time_slot) {
      let reservation_time_slotElement = document.getElementById(
        "reservation_time_slot"
      );
      reservation_time_slotElement.focus();
    } else if (formik.errors && formik.errors.auto_cancel) {
      let auto_cancelElement = document.getElementById("auto_cancel");
      auto_cancelElement.focus();
    }
    // else if (formik.errors && formik.errors.min_person) {
    //   let min_personElement = document.getElementById("min_person");
    //   min_personElement.focus();
    // }
  }, [count]);

  useEffect(() => {
    const reservation = {
      ...(props.subscriptionData && props.subscriptionData),
    };
    if (reservation.minimum_person) {
      formik.setFieldValue("minimum_person", reservation.minimum_person);
    }
    if (reservation.table_kept_for) {
      formik.setFieldValue("table_kept_for", reservation.table_kept_for);
    }
    if (reservation.minimum_lead) {
      formik.setFieldValue("minimum_lead", reservation.minimum_lead);
    }
    if (reservation.cut_off_time) {
      formik.setFieldValue("cut_off_time", reservation.cut_off_time);
    }
    if (reservation.max_day_ahead) {
      formik.setFieldValue("max_day_ahead", reservation.max_day_ahead);
    }
    if (reservation.reservation_capacity) {
      formik.setFieldValue(
        "reservation_capacity",
        reservation.reservation_capacity
      );
    }
    if (reservation.reservation_time_slot) {
      formik.setFieldValue(
        "reservation_time_slot",
        reservation.reservation_time_slot
      );
    }
    if (reservation.auto_accept && reservation.auto_accept.min_person) {
      formik.setFieldValue(
        "min_person",
        reservation.auto_accept && reservation.auto_accept.min_person
      );
    }
    if (reservation && reservation.auto_cancel) {
      formik.setFieldValue(
        "auto_cancel",
        reservation && reservation.auto_cancel
      );
    }
    if (!isEmpty(reservation) && !isEmpty(reservation?.order_ahead)) {
      formik.setFieldValue(
        "order_ahead",
        reservation && reservation?.order_ahead
      );
    }

    setState({
      ...state,
      same_day_reservation: !isEmpty(reservation.same_day_reservation)
        ? reservation.same_day_reservation
        : false,
      casualReservationAutoAccept: !isEmpty(
        reservation.auto_accept && reservation.auto_accept.value
      )
        ? reservation.auto_accept && reservation.auto_accept.value
        : false,
    });
  }, [props.subscriptionData]);

  const [disabled, setDisable] = useState(
    props?.history?.location?.state?.access === "view" ? true : false
  );

  const onChangeOrderAhead = () => {
    formik.setFieldValue("order_ahead", !formik.values.order_ahead);
  };

  if (props.auth.loader === true) {
    return (
      <React.Fragment>
        <AmealioLoader />
      </React.Fragment>
    );
  } else {
    return (
      <React.Fragment>
        <div className="container-fluid">
          <div className="row">
            <div className="left-side-panel">
              <LeftSideNavigation />
            </div>

            <div className="top-panel">
              <TopNavigationBarMobile displayLeft="logo" />
            </div>
            <div className="right-side-panel">
              <RightSideNavigation
                leftText="vendorReview"
                backButtonLink="/edit-seating-subscription"
                displayText="Back"
              />
              <div className="col-12 col-md-6 bg-transparent pt-md-0 pt-lg-0 pt-xl-0">
                <div className="mb-4">
                  <TopTextReusableComponent
                    headingText="Reservation Settings"
                    // displayEdit={state.editButton}
                    // onClickEdit={editClick}
                  />
                </div>
                <div className="inside-event-offline-online-text">
                  <div className="row margin-between-toggler mt-4">
                    <div className="col-8">
                      <h4 className="f14-700">Minimum Person</h4>
                    </div>
                    <div className="col-4">
                      <NewInputText
                        extraClass="mb-1"
                        name="minimum_person"
                        onInput={maxLengthCheck}
                        maxLength={5}
                        //onKeyDown={InputNumberFunc}
                        onKeyPress={(event) => {
                          if (!/[0-9]/.test(event.key)) {
                            event.preventDefault();
                          }
                        }}
                        inputType="number"
                        onKeyDown={InputNumberFunc}
                        onFocusOut={formik.handleBlur}
                        onChange={formik.handleChange}
                        value={formik.values.minimum_person}
                        labelText="Pax"
                        controlClass="minimum_person"
                        disabled={disabled}
                      />
                      {formik.errors.minimum_person &&
                      formik.touched.minimum_person ? (
                        <div className="pho_14_regular text-danger">
                          {formik.errors.minimum_person}
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div className="row margin-between-toggler mt-4">
                    <div className="col-8">
                      <h4 className="f14-700">Table is kept for</h4>
                      <p className="f11-400 opacity5">
                        (Table is kept for stipulated time and cancelled)
                      </p>
                    </div>
                    <div className="col-4">
                      <FormControl variant="outlined" className={"w-100"}>
                        <InputLabel htmlFor="outlined-Minutes">
                          Minutes
                        </InputLabel>
                        <Select
                          label="Minutes"
                          name="table_kept_for"
                          id="table_kept_for"
                          className={`w-100 ${
                            formik.errors.table_kept_for &&
                            formik.touched.table_kept_for
                              ? "enError outlined-Minutes"
                              : "outlined-Minutes"
                          }`}
                          onChange={formik.handleChange}
                          value={formik.values.table_kept_for}
                          onBlur={formik.handleBlur}
                          isInvalid={
                            formik.errors.table_kept_for &&
                            formik.touched.table_kept_for
                          }
                          disabled={disabled}
                          // className="outlined-Minutes"
                          IconComponent={KeyboardArrowDownIcon}
                        >
                          <MenuItem value={5}>5 Mins</MenuItem>
                          <MenuItem value={15}>15 Mins</MenuItem>
                          <MenuItem value={30}>30 Mins</MenuItem>
                          <MenuItem value={45}>45 Mins</MenuItem>
                          <MenuItem value={60}>60 Mins</MenuItem>
                          <MenuItem value={120}>120 Mins</MenuItem>
                          <MenuItem value={180}>180 Mins</MenuItem>
                        </Select>
                        {formik.errors.table_kept_for &&
                        formik.touched.table_kept_for ? (
                          <div className="pho_14_regular text-danger">
                            {formik.errors.table_kept_for}
                          </div>
                        ) : null}
                      </FormControl>
                    </div>
                  </div>
                  <div className="row margin-between-toggler mt-4">
                    <div className="col-8">
                      <h4 className="f14-700">
                        Reservation - Same Day Allowed?
                      </h4>
                      <p className="f11-400 opacity5">
                        (Last reservation as per the reservation time slot below
                        no is at closing time)
                      </p>
                    </div>
                    <div className="col-4">
                      <ToggleButtonWithYesNo
                        activeClass={state.same_day_reservation}
                        checkedBox={state.same_day_reservation}
                        onChange={casualSamedayReservationHandler}
                        extraClass="d-flex align-items-center"
                        extraYesNo="f12-500"
                        disabled={disabled}
                      />
                    </div>
                  </div>
                  {state.same_day_reservation ? (
                    <div className="row margin-between-toggler mt-4">
                      <div className="col-8">
                        <h4 className="f14-700">Minimum Lead Time</h4>
                        <p className="f11-400 opacity5">
                          (Minimum lead time Reservation is to be made)
                        </p>
                      </div>
                      <div className="col-4">
                        <FormControl variant="outlined" className={"w-100"}>
                          <InputLabel htmlFor="outlined-Minutes">
                            Hours
                          </InputLabel>
                          <Select
                            label="Hours"
                            name="minimum_lead"
                            id="minimum_lead"
                            className={`w-100 ${
                              formik.errors.minimum_lead &&
                              formik.touched.minimum_lead
                                ? "enError outlined-Minutes"
                                : "outlined-Minutes"
                            }`}
                            onChange={formik.handleChange}
                            value={formik.values.minimum_lead}
                            onBlur={formik.handleBlur}
                            isInvalid={
                              formik.errors.minimum_lead &&
                              formik.touched.minimum_lead
                            }
                            disabled={disabled}
                            // className="outlined-Minutes"
                            IconComponent={KeyboardArrowDownIcon}
                          >
                            <MenuItem value={0.5}>0.5 Hrs</MenuItem>
                            <MenuItem value={1}>01 Hrs</MenuItem>
                            <MenuItem value={2}>02 Hrs</MenuItem>
                            <MenuItem value={3}>03 Hrs</MenuItem>
                            <MenuItem value={4}>04 Hrs</MenuItem>
                          </Select>
                          {formik.errors.minimum_lead &&
                          formik.touched.minimum_lead ? (
                            <div className="pho_14_regular text-danger">
                              {formik.errors.minimum_lead}
                            </div>
                          ) : null}
                        </FormControl>
                      </div>
                    </div>
                  ) : null}
                  <div className="row margin-between-toggler mt-4">
                    <div className="col-8">
                      <h4 className="f14-700">Cut Off Time - Reservation</h4>
                      <p className="f11-400 opacity5">
                        (Last reservation as per the reservation time slot below
                        no is at closing time)
                      </p>
                    </div>
                    <div className="col-4">
                      <FormControl variant="outlined" className={"w-100"}>
                        <InputLabel htmlFor="outlined-Minutes">
                          Minutes
                        </InputLabel>
                        <Select
                          label="Minutes"
                          name="cut_off_time"
                          id="cut_off_time"
                          className={`w-100 ${
                            formik.errors.cut_off_time &&
                            formik.touched.cut_off_time
                              ? "enError outlined-Minutes"
                              : "outlined-Minutes"
                          }`}
                          onChange={formik.handleChange}
                          value={formik.values.cut_off_time}
                          onBlur={formik.handleBlur}
                          isInvalid={
                            formik.errors.cut_off_time &&
                            formik.touched.cut_off_time
                          }
                          disabled={disabled}
                          // className="outlined-Minutes"
                          IconComponent={KeyboardArrowDownIcon}
                        >
                          <MenuItem value={0}>00 Minute</MenuItem>
                          <MenuItem value={15}>15 Minute</MenuItem>
                          <MenuItem value={30}>30 Minute</MenuItem>
                          <MenuItem value={45}>45 Minute</MenuItem>
                          <MenuItem value={60}>60 Minute</MenuItem>
                        </Select>
                        {formik.errors.cut_off_time &&
                        formik.touched.cut_off_time ? (
                          <div className="pho_14_regular text-danger">
                            {formik.errors.cut_off_time}
                          </div>
                        ) : null}
                      </FormControl>
                    </div>
                  </div>
                  <div className="row margin-between-toggler mt-4">
                    <div className="col-8">
                      <h4 className="f14-700">Maximum Days ahead</h4>
                      <p className="f11-400 opacity5">
                        ( Maximum time ahead reservation can be made)
                      </p>
                    </div>
                    <div className="col-4">
                      <NewInputText
                        extraClass="mb-1"
                        name="max_day_ahead"
                        onInput={maxLengthCheck}
                        maxLength={3}
                        //onKeyDown={InputNumberFunc}
                        onKeyPress={(event) => {
                          if (!/[0-9]/.test(event.key)) {
                            event.preventDefault();
                          }
                        }}
                        inputType="number"
                        onFocusOut={formik.handleBlur}
                        onChange={formik.handleChange}
                        value={formik.values.max_day_ahead}
                        labelText="Days"
                        controlClass="max_day_ahead"
                        disabled={disabled}
                      />
                      {formik.errors.max_day_ahead &&
                      formik.touched.max_day_ahead ? (
                        <div className="pho_14_regular text-danger">
                          {formik.errors.max_day_ahead}
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div className="row margin-between-toggler mt-4">
                    <div className="col-8">
                      <h4 className="f14-700">Reservation Capacity</h4>
                      <p className="f11-400 opacity5">
                        ( How much of seating capacity can be reserved)
                      </p>
                    </div>
                    <div className="col-4">
                      <NewInputText
                        extraClass="mb-1"
                        name="reservation_capacity"
                        onInput={maxLengthCheck}
                        maxLength={3}
                        //onKeyDown={InputNumberFunc}
                        onKeyPress={(event) => {
                          if (!/[0-9]/.test(event.key)) {
                            event.preventDefault();
                          }
                        }}
                        inputType="number"
                        onFocusOut={formik.handleBlur}
                        onChange={formik.handleChange}
                        value={formik.values.reservation_capacity}
                        labelText="Percentage"
                        controlClass="reservation_capacity"
                        disabled={disabled}
                      />
                      {formik.errors.reservation_capacity &&
                      formik.touched.reservation_capacity ? (
                        <div className="pho_14_regular text-danger">
                          {formik.errors.reservation_capacity}
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div className="row margin-between-toggler mt-4">
                    <div className="col-8">
                      <h4 className="f14-700">Reservation Time Slot</h4>
                      <p className="f11-400 opacity5">
                        (Users will be given slots in these intervals to make
                        reservation request during open hours)
                      </p>
                    </div>
                    <div className="col-4">
                      <FormControl variant="outlined" className={"w-100"}>
                        <InputLabel htmlFor="outlined-Minutes">
                          Default 15 minute
                        </InputLabel>
                        <Select
                          label="Default 15 minute"
                          name="reservation_time_slot"
                          id="reservation_time_slot"
                          className={`w-100 ${
                            formik.errors.reservation_time_slot &&
                            formik.touched.reservation_time_slot
                              ? "enError outlined-Minutes"
                              : "outlined-Minutes"
                          }`}
                          onChange={formik.handleChange}
                          value={formik.values.reservation_time_slot}
                          onBlur={formik.handleBlur}
                          isInvalid={
                            formik.errors.reservation_time_slot &&
                            formik.touched.reservation_time_slot
                          }
                          disabled={disabled}
                          // className="outlined-Minutes"
                          IconComponent={KeyboardArrowDownIcon}
                        >
                          <MenuItem value={0}>00 Minute</MenuItem>
                          <MenuItem value={15}>15 Minute</MenuItem>
                          <MenuItem value={30}>30 Minute</MenuItem>
                          <MenuItem value={45}>45 Minute</MenuItem>
                        </Select>
                        {formik.errors.reservation_time_slot &&
                        formik.touched.reservation_time_slot ? (
                          <div className="pho_14_regular text-danger">
                            {formik.errors.reservation_time_slot}
                          </div>
                        ) : null}
                      </FormControl>
                    </div>
                  </div>
                  <div className="row margin-between-toggler mt-4">
                    <div className="col-8">
                      <h4 className="f14-700">Auto Accept</h4>
                    </div>
                    <div className="col-4">
                      <ToggleButtonWithYesNo
                        activeClass={state.casualReservationAutoAccept}
                        checkedBox={state.casualReservationAutoAccept}
                        onChange={casualReservationAutoAcceptHandler}
                        extraClass="d-flex align-items-center"
                        extraYesNo="f12-500"
                        disabled={disabled}
                      />
                    </div>
                  </div>
                  {state.casualReservationAutoAccept ? (
                    <div className="row margin-between-toggler mt-4">
                      <div className="col-8">
                        <h4 className="f14-700">Maximum Person</h4>
                      </div>
                      <div className="col-4">
                        <NewInputText
                          extraClass="mb-1"
                          name="min_person"
                          onInput={maxLengthCheck}
                          maxLength={5}
                          //onKeyDown={InputNumberFunc}
                          onKeyPress={(event) => {
                            if (!/[0-9]/.test(event.key)) {
                              event.preventDefault();
                            }
                          }}
                          inputType="number"
                          onFocusOut={formik.handleBlur}
                          onChange={formik.handleChange}
                          value={formik.values.min_person}
                          labelText="Pax"
                          controlClass="min_person"
                          disabled={disabled}
                        />
                        {formik.errors.min_person &&
                        formik.touched.min_person ? (
                          <div className="pho_14_regular text-danger">
                            {formik.errors.min_person}
                          </div>
                        ) : null}
                      </div>
                    </div>
                  ) : null}
                  <div className="row mt-4 mb-5">
                    <div className=" col-8 col-md-8 col-lg-8">
                      <div className="f14-700">Auto Cancel</div>
                      <div className="f11-400 opacity5">
                        Pending Orders have to be accepted within Specified
                        period Otherwise it will be cancelled
                      </div>
                    </div>
                    <div className="col-4 col-md-4 col-lg-4">
                      <Row>
                        <Col md={12}>
                          <FormControl variant="outlined" className={"w-100"}>
                            <InputLabel htmlFor="outlined-Minutes">
                              Minutes
                            </InputLabel>
                            <Select
                              label="Minutes"
                              name="auto_cancel"
                              id="auto_cancel"
                              className={`w-100 ${
                                formik.errors.auto_cancel &&
                                formik.touched.auto_cancel
                                  ? "enError outlined-Minutes"
                                  : "outlined-Minutes"
                              }`}
                              onChange={formik.handleChange}
                              value={formik.values.auto_cancel}
                              onBlur={formik.handleBlur}
                              isInvalid={
                                formik.errors.auto_cancel &&
                                formik.touched.auto_cancel
                              }
                              disabled={disabled}
                              // className="outlined-Minutes"
                              IconComponent={KeyboardArrowDownIcon}
                            >
                              <MenuItem value={5}>5 Minute</MenuItem>
                              <MenuItem value={10}>10 Minute</MenuItem>
                              <MenuItem value={15}>15 Minute</MenuItem>
                            </Select>
                            {formik.errors.auto_cancel &&
                            formik.touched.auto_cancel ? (
                              <div className="pho_14_regular text-danger">
                                {formik.errors.auto_cancel}
                              </div>
                            ) : null}
                          </FormControl>
                        </Col>
                      </Row>
                    </div>
                  </div>
                  <div className="row margin-between-toggler mt-4 mb-4">
                    <div className="col-8">
                      <div className="f14-700">Order Ahead Facility</div>
                      <div className="f11-400 opacity5">
                        (Enable this option if you have order ahead facility
                        where user can place his order after the reservation
                        request is accepted)
                      </div>
                    </div>
                    <div className="col-4">
                      <ToggleButtonWithYesNo
                        activeClass={formik.values.order_ahead}
                        checkedBox={formik.values.order_ahead}
                        onChange={() => onChangeOrderAhead()}
                        extraClass="d-flex align-items-center"
                        extraYesNo="f12-500"
                        disabled={disabled}
                      />
                    </div>
                  </div>
                </div>
                <br />
                <br />
                <br />
                <div
                  className="onboarding-map-setup-screen-autodetect-button "
                  style={{ marginBottom: "50px" }}
                >
                  <ReusableOnboardingLink
                    buttonTitle="Back Button"
                    buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
                    buttonText="Back"
                    link="/edit-seating-subscription"
                  />
                  {!disabled && (
                    <ReusableOnboardingButton
                      buttonTitle="Next Button"
                      buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_red ml-3"
                      buttonText="Done"
                      buttonType="button"
                      onClick={() => onClickSave()}
                    />
                  )}
                </div>
              </div>
              <Media query="(max-width: 991px)">
                <div className="bottom-panel">
                  <BottomNavigationMobile />
                </div>
              </Media>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
};

EditReservationSubscription.propTypes = {
  auth: PropTypes.object.isRequired,
  update_new_subscription_for_vendor: PropTypes.func.isRequired,
  subscription: PropTypes.object.isRequired,
  subscriptionData: PropTypes.object.isRequired,
  allSubscriptionsData: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  subscription:
    state?.onboarding && state?.onboarding?.onboard_subscription_details,

  /************* Active Service ************/
  casualDiningService:
    state?.onboarding?.onboard_subscription_details?.casual_dining,
  multiDiningService:
    state?.onboarding?.onboard_subscription_details?.multi_service_business,
  /************* Subscription Data ************/
  subscriptionData:
    state?.onboarding?.onboard_subscription_details?.casual_dining &&
    state?.onboarding?.onboard_subscription_details?.casual_dining_status
      ? state?.onboarding?.onboard_subscription_details?.casual_dining_status
          ?.seating?.reservation
      : state?.onboarding?.onboard_subscription_details
          ?.multi_service_business_status?.seating?.reservation,
  /************* All SubscriptionsData Data ************/
  allSubscriptionsData:
    state?.onboarding && state?.onboarding?.onboard_subscription_details,
});

export default connect(mapStateToProps, {
  update_new_subscription_for_vendor,
})(withRouter(EditReservationSubscription));
